import { useEffect, useRef } from "react"
import { useAuthStore } from "stores"
import {
  identifyMixpanelUser,
  initMixpanel,
  stopMixpanelSession,
} from "utils/mixpanel"

export const useMixpanelSession = () => {
  const user = useAuthStore((state) => state.user)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const wasAuthenticated = useRef(false)

  useEffect(() => {
    initMixpanel()
  }, [])

  useEffect(() => {
    if (isAuthenticated && user?.userName) {
      identifyMixpanelUser({
        email: user.userName,
        fullName: user.userFullName,
        company: user.userOrganisation,
        companyId: user.userOrganisationId,
      })
      wasAuthenticated.current = true
    } else if (wasAuthenticated.current) {
      stopMixpanelSession()
      wasAuthenticated.current = false
    }
  }, [
    isAuthenticated,
    user?.userName,
    user?.userFullName,
    user?.userOrganisation,
    user?.userOrganisationId,
  ])
}
